import React from 'react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { formatGroupActivityLine } from '../../api/groupService';
import {
  activityIcon,
  activityTimestampMs,
  formatRelativeTimestamp,
} from '../../utils/groupActivityFormat';
import { typography } from '../../design-system/tokens';

export default function GroupActivityFeed({ events = [], onPostLock, onInvite }) {
  const feedEvents = events.filter((e) =>
    [
      'lock_posted',
      'lock_accepted',
      'member_joined',
      'member_left',
      'member_defeated',
      'weekly_champion',
      'group_created',
    ].includes(e.type)
  );

  if (feedEvents.length === 0) {
    return (
      <Card variant="admin" className="p-4">
        <p className={`${typography.microWide} text-gray-500 mb-2`}>Recent activity</p>
        <p className="text-sm text-gray-400 font-medium mb-3">
          Nothing here yet. Post a lock or invite a friend to get the league moving.
        </p>
        <div className="flex flex-wrap gap-2">
          {onPostLock && (
            <Button type="button" variant="admin" size="sm" onClick={onPostLock}>
              Post a lock
            </Button>
          )}
          {onInvite && (
            <Button type="button" variant="ghost" size="sm" onClick={onInvite}>
              Invite a member
            </Button>
          )}
        </div>
      </Card>
    );
  }

  return (
    <Card variant="admin" className="p-4">
      <p className={`${typography.microWide} text-gray-500 mb-3`}>Recent activity</p>
      <ul className="space-y-2.5">
        {feedEvents.slice(0, 12).map((event) => {
          const ts = activityTimestampMs(event);
          return (
            <li
              key={event.id}
              className="flex items-start gap-2.5 text-sm font-bold text-gray-200 border-l-2 border-violet-500/30 pl-3 py-0.5"
            >
              <span className="text-base leading-none mt-0.5 shrink-0" aria-hidden>
                {activityIcon(event.type)}
              </span>
              <div className="min-w-0 flex-1">
                <p>{formatGroupActivityLine(event)}</p>
                {ts && (
                  <p className="text-[10px] font-bold text-gray-500 mt-0.5">
                    {formatRelativeTimestamp(ts)}
                  </p>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
